import React from 'react'
import strings from 'utils/strings'

import PanelPartDetails from 'components/SwitchAndGauge/DashDrawer/PanelPartDetails'
import {
  Header,
  Content,
  Footer,
} from 'components/SwitchAndGauge/DashDrawer/Sections'
import Breadcrumb from 'components/SwitchAndGauge/DashDrawer/Breadcrumb'
import { Button, FlexRow, FlexCol } from 'components/patterns'
import { useSelector } from 'hooks/redux'
import { RESET, SAVE, DASH_VIEW } from 'utils/constants'
import { getSwitchDetailsChange } from 'selectors/dash'
import { setSelectedIdWithDrawerAndMeta } from 'actions/navigator'
import { useDispatch } from 'react-redux'
import { StyledViewWrap } from './style'

const DetailsView = () => {
  const dispatch = useDispatch()
  const showFooter = useSelector(getSwitchDetailsChange)

  const handleOnReset = () => {
    dispatch(
      setSelectedIdWithDrawerAndMeta(DASH_VIEW, {
        view: RESET,
      })
    )
  }

  const handleOnSave = () => {
    dispatch(
      setSelectedIdWithDrawerAndMeta(DASH_VIEW, {
        view: SAVE,
      })
    )
  }

  return (
    <StyledViewWrap>
      <Header>
        <Breadcrumb />
      </Header>
      <Content>
        <PanelPartDetails />
      </Content>
      {showFooter && (
        <Footer styles={{ borderTop: 'none' }}>
          <FlexRow>
            <FlexCol span={12}>
              <div>
                <Button type="secondary" onClick={handleOnReset}>
                  {strings.reset}
                </Button>
              </div>
            </FlexCol>
            <FlexCol span={12} alignItems="end">
              <div>
                <Button onClick={handleOnSave}>{strings.save}</Button>
              </div>
            </FlexCol>
          </FlexRow>
        </Footer>
      )}
    </StyledViewWrap>
  )
}

export default DetailsView
